<template>
    <div class="publictemplate">
        <!-- Bar atas DIBUANG. Ia hanya memegang tiga perkara, dan kesemuanya
             kini duduk di dalam kad <AuthShell> tempat ia lebih berguna:
             penukar bahasa dan Manual Pengguna dalam kad itu sendiri, Lupa Kata
             Laluan tepat di bawah medan kata laluan yang gagal. -->
        <v-app class="app-shell">
        <v-main>
          <!-- <v-container> -->
            <router-view></router-view>
          <!-- </v-container> -->
        </v-main>
        </v-app>
    </div>
</template>
<script>
export default {
    name: 'publictemplate',
    setup() {

    },
}
</script>

<style scoped>
/* Latar halaman awam (dahulu: `background: #EEEEEE` sebaris pada <v-app>).

   PENTING — kenapa dicat pada `.v-application--wrap` dan bukan `.v-application`:
   belasan halaman kemasukan data mengisytiharkan
   `#app { background: url(HIES.jpg) … !important }` dalam blok <style> TANPA
   `scoped`. Peraturan itu GLOBAL: sebaik sahaja mana-mana halaman itu dimuatkan,
   ia kekal dan mengecat `#app` — bekas LUAR bagi `.v-application` — pada setiap
   halaman, termasuk skrin log masuk selepas log keluar. `.v-application--wrap`
   berada DI ATAS `#app`, jadi mengecat di sini menang tanpa perlu melawan
   `!important` halaman lain.

   KENAPA lapisan `position: fixed` dan BUKAN latar terus pada elemen itu:
   elemen hanya setinggi kandungannya, jadi pada halaman panjang (Daftar, Lupa
   Kata Laluan, atau borang log masuk pada skrin pendek) kecerunan akan tamat
   dan meninggalkan jalur kosong apabila ditatal. Lapisan `fixed` sentiasa
   menutupi seluruh viewport — latar kelihatan tidak berpenghujung tidak kira
   sepanjang mana halaman itu.

   Palet SAMA seperti maintemplate: pengguna melihat latar yang sama sebelum
   dan selepas log masuk. */
.app-shell ::v-deep .v-application--wrap {
  position: relative;
  background: transparent;
}

.app-shell ::v-deep .v-application--wrap::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(1100px 620px at 96% -6%, rgba(95, 227, 211, .42), transparent 60%),
    radial-gradient(950px 600px at -8% 106%, rgba(3, 119, 105, .28), transparent 58%),
    radial-gradient(760px 500px at 74% 66%, rgba(224, 168, 0, .16), transparent 62%),
    radial-gradient(820px 520px at 4% -8%, rgba(11, 31, 58, .10), transparent 56%),
    linear-gradient(160deg, #eaf6f4 0%, #dceeeb 40%, #cfe6e2 72%, #c6e0dc 100%);
}

/* Kandungan mesti di atas lapisan latar. */
.app-shell ::v-deep .v-main {
  position: relative;
  z-index: 1;
}
</style>